module.exports = __webpack_public_path__ + "static/media/slide4.80aab751.png";